import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrganizationService } from '../../organization.service';
import type { OrganizationAddressAddDialogData } from '@/organization/organization/organization.model';

@Component({
	selector: 'app-organization-address-add',
	templateUrl: './organization-address-add.component.html',
	styleUrls: ['./organization-address-add.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationAddressAddComponent {
	readonly service = inject(OrganizationService);
	readonly data = inject<OrganizationAddressAddDialogData | null>(MAT_DIALOG_DATA, { optional: true });
	readonly formAdress = new FormGroup({
		address: new FormControl(this.data?.address.address ?? null, [Validators.required]),
		zipCode: new FormControl(this.data?.address.zipCode ?? null, [Validators.required]),
		location: new FormControl(this.data?.address.location ?? null, [Validators.required]),
		type: new FormControl(this.data?.address.kind ?? null, [Validators.required]),
	});

	private readonly dialogRef = inject<MatDialogRef<OrganizationAddressAddComponent, boolean>>(MatDialogRef);

	addAddress(): void {
		if (this.formAdress.invalid) {
			this.formAdress.markAllAsTouched();
			return;
		}
		const value = this.formAdress.getRawValue();
		this.service.organizationData.address.push({
			address: value.address,
			zipCode: value.zipCode,
			location: value.location,
			kind: value.type,
		});
		this.dialogRef.close(true);
	}
}
